import { useDynamicConfig } from '@statsig/react-bindings';

import { EventType } from '@/analytics/types';

import type { DiscountDifferenceData } from './HolidayHeroTemplate25';
import SDBFCMHeroTemplate2025 from './HolidayHeroTemplate25';

const SinglesDay = () => {
  const discountDifferenceData = useDynamicConfig(
    'singles_day_hero_title_price',
  ).value;

  return (
    <SDBFCMHeroTemplate2025
      discountDifferenceData={
        discountDifferenceData as unknown as DiscountDifferenceData
      }
      tagMsgKey="singles_day_tag"
      titleMsgKey="singles_day_hero_title"
      subcopyMsgKey="singles_day_subcopy"
      buttonProps={{
        href: '/store/rings/oura-ring-4/silver',
        ctaLabel: 'shop_sale',
        onClick: () => {
          void window.ouraAnalytics.track(EventType.CTAClicked, {
            cta: 'shop_sale',
            action: 'go_to_pdp',
            location: 'home hero',
            path: '/store/rings/oura-ring-4/silver',
          });
        },
      }}
    />
  );
};
export default SinglesDay;
